/**
 * Adds toggle functionality for the panels.
 */
export const panel = {

  /**
   * Css class of the panel header.
   * @type String
   */
  cssClass: 'panel__header',

  /**
   * Css classes for the different collapsed states.
   * @type String
   */
  cssClassCollapsable: 'panel_collapsable',
  cssClassCollapsed: 'panel_collapsed',
  cssClassCollapsedLeft: 'panel_lcollapsed',
  cssClassCollapsedRight: 'panel_rcollapsed',

  /**
   * @type {module:map}
   */
  map: null,

  /**
   * Initialize the panel.
   * @param {module:map} map
   * @returns {void}
   */
  init (map) {
    this.map = map;
    this.initEvents();
  },

  /**
   * Initialize the events
   * @returns {void}
   * @private
   */
  initEvents () {
    const nl = document.getElementsByClassName(this.cssClass);
    for (const area of nl) {
      area.addEventListener('click', this.toggle.bind(this));
    }
  },

  /**
   * Toggle the collapsing of the panel.
   * After collapsing and if there is more space available, the map will be expanded and re-centered.
   * @param {MouseEvent} evt
   * @returns {void}
   * @private
   */
  toggle (evt) {
    let el, css, cssQuery;
    const parent = evt.currentTarget.parentElement,
      panel = evt.target.parentElement,
      colMiddle = document.querySelector('.column__middle');

    css = this.cssClassCollapsed;
    parent.classList.toggle(css);

    el = evt.target.closest('.column');
    cssQuery = '.' + this.cssClassCollapsable + ':not(.' + this.cssClassCollapsed + ')';
    if (el.querySelector(cssQuery) === null) {  // all are additionally l/r collapsable, because all are collapsed
      this._fold(el, true);
    } else {  // at least one is not collapsed
      this._fold(el, false);
    }

    // There is a bug in FF, where the left or right column completely collapses when setting the writing mode (via CSS class).
    //  Also, the (right) column is sometimes pushed outside the visible viewport because of the middle column being set to flex:auto.
    panel.classList.toggle('ff-bug');

    colMiddle.removeAttribute('style');
    this.map.map.once('rendercomplete', () => {
      this.map.centerView();
      if (panel.classList.contains('panel_rcollapsed') && !this._inViewPort(panel) && !this._isCssMediaMobile()) {
        colMiddle.style.width = (colMiddle.getBoundingClientRect().width - panel.getBoundingClientRect().width) + 'px';
        colMiddle.style.flex = 'unset';
      }
    });
  },

  /**
   * Fold or unfold the collapsable panel left or right.
   * @param {HTMLDivElement} el the left or right column
   * @param {Boolean} force
   * @private
   */
  _fold (el, force) {
    el.querySelectorAll('.' + this.cssClassCollapsable).forEach(node => {
      const css = el.classList.contains('column__left') ? this.cssClassCollapsedLeft : this.cssClassCollapsedRight;
      node.classList.toggle(css, force);
    });
  },

  _inViewPort (el) {
    var rect = el.getBoundingClientRect();

    return (
      rect.top >= 5 &&
      rect.left >= 5 &&
      rect.bottom <= window.innerHeight + 5 &&
      rect.right <= window.innerWidth + 5
    );
  },

  /**
   * Is the css media query mobile breakpoint reached ?
   * @returns {boolean}
   */
  _isCssMediaMobile () {
    return window.getComputedStyle(document.body, '::after').content.includes('mobile');
  },

};